import { createTheme } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

import getOverrides from "./overrides";

export const createCustomTheme = (theme: Theme): Theme =>
  createTheme({
    ...theme,
    components: getOverrides(theme),
  });
